import React from "react";
import Label from "../atoms/Label";
import contentfulRichText from "../util/contentfulRichText";
import { markdownToJSX } from "../../util/transforms";

export default ({ layout, label, title, text }) => {
    return (
        <section
             className={ "u-container u-section-spacing " +
            (layout ? " u-container--large u-center-text" : " u-container--medium") }
        >
            <Label text={ label }/>
            { title && <h2>{ markdownToJSX(title) }</h2> }
            { contentfulRichText(text) }
        </section>
    )
}
